<template>
  <div class="page">
    <div class="box">
      <div class="title">确认订单信息</div>

      <div class="section">
        <div class="section-title">所选套餐</div>
        <div class="pkg-name">{{ pkg }}</div>
        <img v-if="pkgImg" :src="pkgImg" class="pkg-img" @click="previewImg = pkgImg">
      </div>

      <div class="section">
        <div class="section-title">收货信息</div>
        <div class="info-row"><span class="label">收货人</span><span>{{ name }}</span></div>
        <div class="info-row"><span class="label">联系电话</span><span>{{ phone }}</span></div>
        <div class="info-row"><span class="label">收货地址</span><span>{{ fullAddr }}</span></div>
      </div>

      <div class="section">
        <div class="section-title">备注留言</div>
        <textarea v-model="remark" placeholder="如有特殊需求请在此留言（选填）" rows="3"></textarea>
      </div>

      <button :disabled="submitting" @click="submitOrder">
        {{ submitting ? '提交中...' : '确认无误，提交发货' }}
      </button>
    </div>

    <teleport to="body">
      <div v-if="previewImg" class="preview-overlay" @click="previewImg = null">
        <img :src="previewImg" class="preview-img">
      </div>
    </teleport>

    <Modal :visible="modal.visible" :title="modal.title" @close="onModalClose">
      <p>{{ modal.msg }}</p>
      <template #footer>
        <button class="modal-btn" @click="onModalClose">确定</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { getTheme } from '@/utils/theme';
import { saveCardSession } from '@/utils/cardSession';

export default {
  name: 'ConfirmPage',
  components: { Modal },
  data() {
    return {
      card: '',
      cardKey: '',
      pkg: '',
      name: '',
      phone: '',
      province: '',
      city: '',
      detailAddr: '',
      remark: '',
      previewImg: null,
      submitting: false,
      modal: { visible: false, title: '', msg: '', onOk: null }
    };
  },
  computed: {
    fullAddr() {
      return this.province + this.city + this.detailAddr;
    },
    pkgImg() {
      return sessionStorage.getItem('pkgImg') || '';
    }
  },
  created() {
    this.card = sessionStorage.getItem('card') || '';
    this.cardKey = sessionStorage.getItem('cardKey') || '';
    this.pkg = sessionStorage.getItem('pkg') || '';
    this.name = sessionStorage.getItem('shipName') || '';
    this.phone = sessionStorage.getItem('shipPhone') || '';
    this.province = sessionStorage.getItem('shipProvince') || '';
    this.city = sessionStorage.getItem('shipCity') || '';
    this.detailAddr = sessionStorage.getItem('shipDetailAddr') || '';

    if (!this.card || !this.cardKey || !this.pkg || !this.name || !this.phone || !this.province || !this.city || !this.detailAddr) {
      this.showModal('提示', '请按顺序操作', () => this.$router.replace('/verify'));
    }
  },
  methods: {
    showModal(title, msg, onOk) {
      this.modal = { visible: true, title, msg, onOk: onOk || null };
    },
    onModalClose() {
      this.modal.visible = false;
      if (this.modal.onOk) this.modal.onOk();
    },
    async submitOrder() {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        this.showModal('提示', '请输入正确的手机号码');
        return;
      }
      this.submitting = true;

      try {
        const res = await fetch('/api/activate', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            cardNo: this.card,
            cardKey: this.cardKey,
            site: sessionStorage.getItem('site') || getTheme(),
            pkg: this.pkg,
            name: this.name,
            phone: this.phone,
            province: this.province,
            city: this.city,
            detailAddr: this.detailAddr,
            remark: this.remark
          })
        });
        const data = await res.json();
        if (data.code === 200) {
          saveCardSession(this.card, this.cardKey);
          this.showModal('提示', '兑换提交成功，商家将尽快安排发货！', () => {
            this.$router.replace('/logistics?cardNo=' + this.card);
          });
        } else {
          this.showModal('提示', data.message || '提交失败');
        }
      } catch {
        this.showModal('提示', '网络错误，请稍后重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.page {
  min-height: 100vh;
  padding: 20px 15px;
}
.box {
  max-width: 420px;
  margin: 0 auto;
  background: #fff;
  padding: 25px 20px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border-top: 5px solid var(--color-primary);
}
.title {
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1a1a1a;
  letter-spacing: 1px;
}
.section {
  margin-bottom: 20px;
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--color-primary);
  margin-bottom: 10px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--color-primary-soft);
}
.pkg-name {
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  padding: 10px 14px;
  background: var(--color-primary-bg2);
  border-radius: 8px;
  margin-bottom: 10px;
}
.pkg-img {
  width: 100%;
  max-height: 200px;
  object-fit: contain;
  display: block;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #f0f0f0;
  transition: border-color 0.2s;
}
.pkg-img:hover {
  border-color: var(--color-primary);
}
.info-row {
  display: flex;
  padding: 8px 0;
  font-size: 15px;
  color: #333;
}
.info-row .label {
  flex-shrink: 0;
  width: 70px;
  color: #999;
}
textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border: 1px solid #eaeaea;
  background-color: #fafbfc;
  border-radius: 10px;
  font-size: 15px;
  color: #333;
  transition: all 0.3s ease;
  outline: none;
  resize: none;
}
textarea:focus {
  border-color: var(--color-primary-light);
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}
button {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, var(--color-primary-light), var(--color-primary));
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 17px;
  font-weight: 600;
  margin-top: 5px;
  cursor: pointer;
  box-shadow: 0 4px 15px var(--color-primary-shadow);
  transition: all 0.2s ease;
}
button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--color-primary-shadow-hover);
}
button:disabled {
  opacity: 0.6;
  transform: none;
  cursor: not-allowed;
}
.modal-btn {
  width: auto;
  padding: 10px 32px;
  margin-top: 0;
}
.preview-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.9);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.preview-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
</style>
